'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Chip_module = require('./Chip.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const computeBorderRadius = rounded => {
  switch (rounded) {
    case 'small':
      return 2;
    case 'medium':
      return 4;
    case 'large':
      return 8;
    case 'full':
      return 999;
    default:
      return 0;
  }
};
const Chip = _ref => {
  let {
    color = '#fff',
    fill = '#000',
    rounded = 'full',
    icon,
    action,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("span", _extends__default["default"]({
    className: Chip_module["default"].chipRoot,
    style: {
      backgroundColor: fill,
      color,
      borderRadius: computeBorderRadius(rounded)
    }
  }, props), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Chip_module["default"].chipWrapper
  }, icon, children, action));
};

exports["default"] = Chip;
